import { Component, Inject, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import { Config } from '../universal-config';
import { ShareCopyService } from '../share';
import {NoteService} from "../share/note/note.service";

@Component({
  selector: 'nns-header-actions',
  template: `
    <div class="nns-header-actions-layout"
      flex="none" layout="row" layout-align="end center"
      [ngClass]="{'nns-mobile-folder-type-hide': !childrenNotesCount && note?.type == 'folder'}"
    >
      <div flex="none" layout="row" layout-align="start center" hideQuery="mobile tablet"
        *ngIf="note?.type == 'folder'"
      >
        <nns-header-list-type-selector [visual]="visual"></nns-header-list-type-selector>
      </div>

      <div class="nns-header-buttons" flex="none" layout="row" layout-align="start center">
        <nns-header-theme-selector [visual]="visual"></nns-header-theme-selector>
      </div>

      <div class="nns-header-save nns-animated" *ngIf="branding.sharesShareButton" flex="none" layout="row" layout-align="start center">
        <nns-save-action
          *ngIf="note?.globalId && !note.isEncrypted && !attachment"
          [isPrimary]="true"
          [login]="login"
          [share]="share"
          [state]="getSaveState()"
          [note]="note"
          [shareCopy]="shareCopy"
          [showTitle]="true"
          [visual]="visual"
        ></nns-save-action>
      </div>

      <div class="nns-header-buttons"
           *ngIf="note?.type != 'folder'"
           flex="none" layout="row" layout-align="start center" hideQuery="mobile">
        <div class="nns-header-search" (click)="onToggleSearch()">
          <nns-icon icon="search"></nns-icon>
        </div>
      </div>

      <div
        *ngIf="profile"
        class="nns-header-buttons" flex="none" layout="row" layout-align="start center">
        <nns-header-profile flex="nogrow"
          [profile]="profile"
          [note]="note"
          [share]="share"
          [shareOrganization]="shareOrganization"
          [visual]="visual"
          [workspaces]="workspaces"
          clickOutside
        ></nns-header-profile>
      </div>


      <div class="nns-header-buttons nns-header-buttons_list-type" flex="none" layout="row" layout-align="start center" hideQuery="desktop"
        *ngIf="note?.type == 'folder'"
      >
        <nns-header-list-type-selector-mobile [visual]="visual"></nns-header-list-type-selector-mobile>
      </div>
    </div>
  `,
  styles: [`
    .nns-header-actions-layout {
      padding:10px 0;
    }

    .nns-header-save {padding:0 10px; position: relative;}

    .nns-header-buttons {
      padding: 10px;
      border-radius: 50%;
      background: transparent;
      transition: 0.3s;
    }

    .nns-header-buttons:hover{
      background: #F5F8FA;
    }

    .nns-header-button-item {padding:0 4px;}

    .nns-header-button-holder {position:relative;}
    .nns-header-button-dropdown {
      position:absolute;
      top:100%;
      margin:10px 0 0 0;
      z-index:500;
      right:0;
    }

    .nns-header-buttons.nns-header-buttons_list-type{
      background-color: transparent;
    }

    .nns-header-search{
      cursor: pointer;
    }

    .nns-header-search nns-icon{
      min-width: 16px;
      min-height: 16px;
    }

    :host-context(.nns-theme-night) .nns-header-buttons:hover{
      background: #20252B;
    }


    @media only screen and (max-width: 768px) {
      .nns-header-buttons, .nns-header-save{
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-color: transparent;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .nns-header-save{
        margin-right: 4px;
      }

      .nns-header-save:hover{
        background: #F5F8FA;
      }

      .nns-header-buttons:not(:last-child){
        margin-right: 4px;
      }

      .nns-header-buttons nns-header-action{
        margin: 0;
      }

      :host-context(.nns-theme-night) .nns-header-buttons.nns-header-buttons_list-type{
        background-color: transparent;
      }

      :host-context(.nns-theme-night) .nns-header-save:hover{
        background: #20252B;
      }
    }

    @media only screen and (max-width: 600px) {
      .nns-header-buttons {padding:0;}

      .nns-header-buttons nns-header-action {margin:0 8px;}
      .nns-header-buttons > nns-save-button {margin:0 4px;}
      .nns-mobile-folder-type-hide .nns-header-buttons_list-type{display: none;}

    }
  `]
})

export class HeaderActionsComponent {
  @Input() public profile;
  @Input() public attachment;
  @Input() public visual;
  @Input() public note;
  @Input() public login;
  @Input() public share;
  @Input() public shareCopy;
  @Input() public branding;
  @Input() public childrenNotesCount;
  @Input() public shareOrganization;
  @Input() public workspaces;
  downloadButtonUrl = undefined;
  shareUrl: string;

  constructor(
    public _store: Store<IAppState>,
    public _config: Config,
    public _shareCopyService: ShareCopyService,
    @Inject('isBrowser') public isBrowser: boolean,
    private noteService: NoteService,
  ) {}

  ngOnChanges() {
    if(this.share && this.share.shareUrl && this.isBrowser) {
      this.shareUrl = window.location.origin + '/s' + this.share.shareUrl;
    }
  }

  onToggleSearch() {
    if(this.visual.isShowSearch) {
      this.noteService.startSearch(true);
    } else {
      this.noteService.startSearch();
    }
  }

  getSaveState() {
    return this.shareCopy.shareCopyStatus;
  }
}
